<template>
  <ul class="container-card">
    <li class="item-card">
      <a :href="card.projectLink" target="_blank" rel="noopener noreferrer"
        ><Tilt :options="tiltOption"
          ><img :src="card.projectPhoto" :alt="card.alt" /></Tilt
      ></a>
    </li>
    <li class="item-card">
      <a
        :href="card.repositorieLink"
        target="_blank"
        rel="noopener noreferrer"
        class="title-card"
        ><h3 v-text="card.title"></h3
      ></a>
    </li>
    <li class="item-card">
      <ul class="container-stack">
        <li v-for="(item, index) in card.stack" :key="index">{{ item }}</li>
      </ul>
    </li>
  </ul>
</template>

<script>
import Tilt from "vanilla-tilt-vue";

export default {
  name: "CardVue",
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const tiltOption = {
      perspective: 400,
      scale: 1,
    };
    return { tiltOption };
  },
  components: { Tilt },
};
</script>

<style scoped>
.container-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--bg-cards);
  padding: 1.875rem 0;
  height: 400px;
  border-radius: 15px;
}

.item-card + .item-card {
  margin-top: 1.563rem;
}

.container-card img {
  width: 228px;
  border-radius: 15px;
}

.title-card {
  display: block;
  color: var(--color-text);
  font-family: "Montserrat";
  text-align: center;
  transition: color 0.3s;
}

.title-card:hover {
  color: var(--bg-color);
}

.container-stack {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-text);
  font-family: "Raleway";
}

.container-stack li + li {
  margin-left: 1.25rem;
}

@media (min-width: 1000px) {
  .container-card {
    width: 100%;
  }
}
</style>
